import React, { PropsWithChildren, useEffect } from 'react';
import { useInView } from 'react-intersection-observer';
import { inViewStyle } from './in-view.styles.css';

type InViewProps = {
    children: React.ReactNode;
    onInView: () => void;
};

const InView: React.FC<PropsWithChildren<InViewProps>> = ({
    children,
    onInView
}) => {
    const { ref, inView } = useInView({
        triggerOnce: true
    });

    useEffect(() => {
        if (inView) {
            onInView();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [inView]);

    return (
        <div ref={ref}>
            <div className={inViewStyle}>{children}</div>
        </div>
    );
};

export { InView };
